import * as React from 'react';
import classNames from 'classnames';

export default function Microsoft(props) {
    const { className, ...others } = props;
    return (
        <svg
            className={classNames('icon', className)}
            viewBox="0 0 23 23"
            width="23"
            height="23"
            xmlns="http://www.w3.org/2000/svg"
            {...others}
        >
            <path fill="#f35325" d="M1 1h10v10H1z" />
            <path fill="#81bc06" d="M12 1h10v10H12z" />
            <path fill="#05a6f0" d="M1 12h10v10H1z" />
            <path fill="#ffba08" d="M12 12h10v10H12z" />
        </svg>
    );
}
